module.exports = __webpack_public_path__ + "50e3cb88c432dc3bd9738e4eacd3e7ec.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/fi-2011.png
// module id = 535
// module chunks = 0